import { AfterViewInit, Directive, Input } from '@angular/core';
import { FormCommonDataService } from '../services/form-common-data.service';
import { NgForm } from '@angular/forms';

@Directive({
    selector: '[appCheckFormInit]',
})
// todo: check why do we need this directive
export class CheckFormInitDirective implements AfterViewInit {
    @Input() ngForm: NgForm;

    constructor(private formCommonDataService: FormCommonDataService) {}

    ngAfterViewInit(): void {
        this.formCommonDataService.formInitSubject.next(this.ngForm?.form);
    }
}
